export const whoami = async (args: string[]): Promise<string> => {
  return 'guest';
};
